export default (response) => response.data;
